/**
 * メディアの品質プロファイル情報
 */
export const DisplayMode = {
    FreeView: 'FreeView',
    MultiSelect: 'MultiSelect'
};
export const MarkerEventType = {
    None: 'None',
    Seek: 'Seek'
};
//# sourceMappingURL=ContentSettingsLightPlayer.js.map